import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import {
    DataTransformService,
    IntercityStop,
    LogService,
    NotificationService,
    Product,
    ProductCategory,
    ProductGroup,
    ProductProperty
} from '@ridango/core';

import { Product as WMBProduct } from '../purchase/purchase.model';
import { forkJoin, of } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ProductsByChannelState, ProductsState, ProductActions } from './+state';

@Injectable({
    providedIn: 'root'
})
export class ProductsService {
    constructor(
        @Inject('ENV') private env: any,
        private http: HttpClient,
        private ngRedux: NgRedux<ProductsState>,
        private ngReduxForChannel: NgRedux<ProductsByChannelState>,
        private actions: ProductActions,
        private dataTransformer: DataTransformService,
        private notifications: NotificationService,
        private ls: LogService
    ) {}

    getPriceList(_regionId: number) {
        console.log('DEPRECATED: ProductsService: getPriceList');
        // this.ngRedux.dispatch( this.actions.pricelistFetchStart() );
        // this.coreHttp.get( `${this.env.API_BASE_URL}/${this.env.REGION_ID}/pricelist/clean` )
        //     .map( data => data.json() )
        //     .subscribe(
        //         data => {
        //             const category = data.categories[ 0 ];
        //             let groups: ProductGroup[] = [];
        //             let normalizedGroups: any = {};
        //             let normalizedProducts: any = {};
        //             const productIds = [];
        //             let products: Product[] = [];

        //             category.product_groups = category.product_groups.sort( function ( a: ProductGroup, b: ProductGroup ) {
        //                 return a.group_order > b.group_order ? 1 : a.group_order < b.group_order ? - 1 : 0;
        //             } );

        //             groups = category.product_groups.map( ( g: ProductGroup ) => {
        //                 const group = Object.assign( new ProductGroup, g );
        //                 group.translations = this.dataTransformer.transformObjectTranslations( g, 'name' );

        //                 group.products = group.products.sort( function ( a: Product, b: Product ) {
        //                     return a.order > b.order ? 1 : a.order < b.order ? - 1 : 0;
        //                 } );
        //                 group.productIds = group.products.map( ( p: Product ) => p.product_id );
        //                 const groupProducts = group.products.map( ( p: Product ) => {
        //                     const product = Object.assign( new Product, p );
        //                     productIds.push( product.product_id );
        //                     // assigining some group properties to products aswell
        //                     product.group_id = group.id;
        //                     product.product_type = group.product_type;
        //                     product.product_class = group.product_class;
        //                     product.notification_mask = group.notification_mask;
        //                     product.notification_before_end = group.notification_before_end;
        //                     product.units = group.units;
        //                     product.translations = this.dataTransformer.transformObjectTranslations( p, 'name' );
        //                     product.translations = product.translations.concat( this.dataTransformer.transformObjectTranslations( p, 'short_name' ) );
        //                     product.product_properties = p.product_properties.map( ( pp: ProductProperty ) => {
        //                         return Object.assign( new ProductProperty, pp );
        //                     } );
        //                     normalizedProducts = { ...normalizedProducts, [ product.product_id ]: product };
        //                     return product;
        //                 } );
        //                 products = [ ...products, ...groupProducts ];
        //                 // unsetting products, productIdsOrdered already contain relation, flattening
        //                 delete group.products;
        //                 normalizedGroups = { ...normalizedGroups, [ group.id ]: group };
        //                 return group;
        //             } );

        //             const groupIds = groups.map( g => g.id );
        //             this.ngRedux.dispatch( this.actions.pricelistFetchSuccess( null ) );
        //             this.ngRedux.dispatch( this.actions.setProductGroups( { groupIds: groupIds, groups: normalizedGroups } ) );
        //             this.ngRedux.dispatch( this.actions.setProducts( { productIds: productIds, products: normalizedProducts } ) );
        //         },
        //         err => {
        //             this.ngRedux.dispatch( this.actions.pricelistFetchFailed( err ) );
        //             this.notifications.add( new Notification( this.notifications.notificationTypes.ERROR, err.json() ) );
        //             throw new Error( 'Pricelist fetch failed' + err.json() );
        //         },
        //         () => {
        //             this.ngRedux.dispatch( this.actions.pricelistFetchEnd() );
        //         }
        //     );
    }

    getPriceListRequest(): Observable<any> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/pricelist/clean`;
        return this.http.get(url).pipe(
            map((d: any) => {
                if (d && d.categories) {
                    return d.categories[0];
                }
                return [];
            }),
            map((d: any) => {
                return d.product_groups.sort(function (a: ProductGroup, b: ProductGroup) {
                    return a.group_order > b.group_order ? 1 : a.group_order < b.group_order ? -1 : 0;
                });
            }),
            map((d: any) => {
                return d.map((pg) => {
                    pg.translations = this.dataTransformer.transformObjectTranslations(pg, 'name');
                    pg.products = pg.products.map((product) => {
                        product.group_id = pg.id;
                        product.product_type = pg.product_type;
                        product.product_class = pg.product_class;
                        product.notification_mask = pg.notification_mask;
                        product.notification_before_end = pg.notification_before_end;
                        product.units = pg.units;
                        product.translations = this.dataTransformer.transformObjectTranslations(product, 'name');
                        product.translations = product.translations.concat(
                            this.dataTransformer.transformObjectTranslations(product, 'short_name')
                        );
                        product.translations = product.translations.concat(
                            pg.translations.map((t) => {
                                const tr = Object.assign({}, t);
                                tr.field = 'group_name';
                                return tr;
                            })
                        );
                        product.product_properties = product.product_properties.map((pp: ProductProperty) => {
                            return Object.assign(new ProductProperty(), pp);
                        });

                        return product;
                    });
                    pg.products = pg.products.sort(function (a: Product, b: Product) {
                        return a.order > b.order ? 1 : a.order < b.order ? -1 : 0;
                    });
                    return pg;
                });
            })
        );
    }

    setSelectedProductGroupId(groupId: any) {
        this.ngRedux.dispatch(this.actions.setSelectedGroupId(groupId));
    }

    setSelectedProductId(productId: any) {
        this.ngRedux.dispatch(this.actions.setSelectedProductId(productId));
    }

    getPrices(productIds: any[], origin: IntercityStop, destination: IntercityStop): Observable<any> {
        if (productIds.length === 0 || !origin || !destination) {
            return;
        }
        const requests = productIds.map((productId) => {
            const payload = {
                channel: this.env.CHANNEL,
                product_id: productId,
                origin_stop_area_id: origin.stop_area_id,
                destination_stop_area_id: destination.stop_area_id
            };
            return this.http
                .put(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/ticket-properties/calc`, payload)
                .pipe(catchError((_e) => of(null)));
        });

        const result = forkJoin(requests);
        this.ls.log(this, 'getPrices', result);
        return result;
    }

    getAllPrices(productIds: any[], origin: IntercityStop, destination: IntercityStop): Observable<any> {
        if (productIds.length === 0 || !origin || !destination) {
            return;
        }
        const payload = {
            channel: this.env.CHANNEL,
            products: productIds,
            origin_stop_area_id: origin.stop_area_id,
            destination_stop_area_id: destination.stop_area_id
        };
        const result = this.http.put(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/ticket-properties/calc`, payload);
        this.ls.log(this, 'getAllPrices', result);
        return result;
    }

    getZonePrices(productIds: any[], origin, destination): Observable<any> {
        if (productIds.length === 0 || !origin || !destination) {
            Promise.resolve();
        }

        const originId = origin.id ? origin.id : origin.zone_id;
        const destinationId = destination.id ? destination.id : destination.zone_id;

        const payload = {
            products: productIds,
            origin_zone: originId,
            destination_zone: destinationId
        };

        return this.http.put(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/ticket-properties/zone/calc`, payload);
    }

    getDynamicLengthPrice(
        productId: number,
        starting: string,
        ending: string,
        originZone: number,
        destinationZone: number
    ): Observable<any> {
        const payload = {
            product_id: productId,
            starting: starting,
            ending: ending,
            origin_zone: originZone,
            destination_zone: destinationZone,
            channel: this.env.CHANNEL
        };

        return this.http.put(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/ticket-properties/calc`, payload);
    }

    setPrices(normalizedPrices: any) {
        this.ngRedux.dispatch(this.actions.setMatrixProductPrices(normalizedPrices));
    }

    /* Channel based products logic here */
    fetchProductsByChannel(channel = this.env.CHANNEL): Observable<Product[]> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/products/channel/${channel}`;
        return this.http.get(url).pipe(
            map((p: Product[]) => {
                return p;
            })
        );
    }
    setAllProducts(products: Product[]) {
        let normalizedProducts = {};
        products.map((p) => {
            normalizedProducts = { ...normalizedProducts, [p.product_id]: p };
        });
        const payload = {
            products: products,
            normalized: normalizedProducts
        };
        this.ngRedux.dispatch(this.actions.setProducts(payload));
    }
    setSelectedProduct(product: Product) {
        this.ngRedux.dispatch(this.actions.setSelectedProduct(product));
    }
    fetchMatrixPrices(
        products: Product[],
        origin: IntercityStop,
        destination: IntercityStop,
        _date: Date = null
    ): Observable<any> {
        if (products.length === 0 || !origin || !destination) {
            return;
        }
        const requests = products.map((product) => {
            const payload = {
                channel: this.env.CHANNEL,
                product_id: product.product_id,
                origin_stop_area_id: origin.stop_area_id,
                destination_stop_area_id: destination.stop_area_id
            };
            return this.http.put(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/ticket-properties/calc`, payload);
        });

        const result = forkJoin(requests);
        this.ls.log(this, 'getPrices', result);
        return result;
    }
    setMatrixPrices(prices: any) {
        this.ngRedux.dispatch(this.actions.setMatrixProductPrices(prices));
    }

    setFilteredProducts(products: Product[]) {
        this.ngRedux.dispatch(this.actions.setFilteredProducts(products));
    }

    setTravellerCategoryFilter(traveller: ProductCategory) {
        this.ngRedux.dispatch(this.actions.setTravellerCategoryFilter(traveller));
    }

    fetchProductById(product_id: number | string): Observable<WMBProduct | Product> {
        // /v2/{region_id}/products
        let url: string;
        if (this.env.WMB?.TENANT_ID) {
            // tenant/3/v1/purchase/product/192973-225/channel/web
            url = `${this.env.WMB.WMB_PUBLIC_API}/v1/purchase/product/${product_id}/channel/${this.env.CHANNEL}`;
        } else {
            url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/products/${product_id}`;
        }
        return this.http.get<Product | WMBProduct>(url);
    }

    applyFilters() {
        this.ngRedux.dispatch(this.actions.applyFilters());
    }
}
